import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { IDtoUrl } from 'app/shared/models/security/dto-url.model';
import { IUser } from 'app/shared/models/user.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { SecurityService } from 'app/shared/services/security.service';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-external-customer-payroll',
  templateUrl: 'external-customer-payroll.template.html'
})
export class ExternalCustomerPayrollComponent implements OnInit {
  public nav: any;
  private authenticated = false;
  private errorMessages: any;
  private objUrl = {} as IDtoUrl;
  constructor(private serviceSecurity: SecurityService
    , private configurationService: ConfigurationService
    , private route: ActivatedRoute
    , private config: AppConfig
    , private spinner: NgxSpinnerService
    , private serviceIdentity: IdentityService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['url']) {
        if (this.configurationService.isReady) {
          let u = params['url'];
          this.getRouteByUrl(u);
        } else {
          this.configurationService.settingsLoaded$.subscribe(x => {
            let u = params['url'];
            this.getRouteByUrl(u);
          });
        }
      }
    });
    this.serviceSecurity.authenticationChallengeExternal$.subscribe((res) => {
      this.authenticated = res;
      if (this.authenticated) {
        this.serviceSecurity.GetRolesUser('external-customer-payroll', this.objUrl.route);
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.config.newToast('Validación', 'Datos incorrectos', 'error');
      }
    });
  }
  private getRouteByUrl(url: string): void {
    this.spinner.show()
    this.serviceIdentity.getRouteByUrl(url)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.spinner.hide();
            this.objUrl = x.data as IDtoUrl;
            this.login();
          } else {
            this.config.newToast('Error', x.message, 'error');
          }
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private login() {
    let user = {} as IUser;
    user.system = this.config.getConfig().name;
    user.username = this.objUrl.user;
    user.password = this.objUrl.password;
    this.serviceSecurity.GetAuthorizationExternalUser(user);
  }
}
